import { CustomerDetailDto, CustomerEditDto } from './customer';

export const mapCustomerDetailToEdit = (
  dto: CustomerDetailDto
): CustomerEditDto => ({
  id: dto.id,
  no: dto.no,
  name: dto.name
});
